<template lang="pug">
.privilege-container(v-if="show", @touchmove.prevent)
  .privilege
    .privilege-block
      .limit-time
      .go-app(@click="goUse") 立即去APP使用
    .modal-close(@click="closeModal")
  .shadow
</template>
<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  components: {
    Lottie,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    goUse() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_VIPappPOP',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('goUrl');
    },
  },
};
</script>

<style lang="less" scoped>
.privilege-container {
  .privilege {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 330;

    .privilege-block {
      width: 3.2rem;
      height: 2.8rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/22871/5klk2xJ67N.png);
      background-size: 100% 100%;
      border-radius: 0.12rem;
      padding: 1.14rem 0.12rem 0.2rem 0.2rem;
      font-weight: 500;

      .limit-time {
        font-size: 0.14rem;
        color: #76431e;
      }

      .go-app {
        margin: 0.94rem auto 0 auto;
        width: 2.56rem;
        height: 0.48rem;
        text-align: center;
        color: #fff;
        line-height: 0.48rem;
        border-radius: 0.5rem;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      }
    }

    .modal-close {
      background: url(https://m.hellobike.com/resource/helloyun/08345/KyfI3xjHl3.png) no-repeat;
      background-size: 100%;
      width: 0.32rem;
      height: 0.32rem;
      z-index: 330;
      margin: 0.4rem auto 0 auto;
      display: flex;
      justify-content: center;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
